import { ThemeCategoryName } from "./types";

export const THEME_CATEGORY_LABELS: { [k in ThemeCategoryName]: string } = {
	template: "Templates",
	reaction: "Reaction",
	stickerPack: "Decals",
	palette: "Colors",
};

/**
 * In addition to the preferred reactions from sticker packs, these emojis
 * are also available for selection in advanced theme customization.
 */
export const EMOJI_REACTIONS = ["💫", "👍", "🔥", "🫶", "🚀", "💋", "🤍", "✅"];
